import { Layout } from './Layout';
import { CartItemProps } from '../../types';
import { Icon } from '../../../Product/components/Icon';

export const Item: React.FC<CartItemProps> = ({
	size,
	product,
	...props
}) => (
	<Layout
		icon={<Icon {...product} />}
		name={`${size ? size + ' ' : ''}${product.name}`}
		{...props}
	/>
);
